import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { environment } from '@environment';

import { GtmService } from '@app/core/services/analytics/gtm.service';
import { BannerService } from '@app/core/services/banner/banner.service';
import { OutletService } from '@app/core/services/outlet/outlet.service';
import { StorageService } from '@app/core/services/util/storage.service';
import { PslaService } from '@app/core/services/psla/psla.service';

import { DeferImageLoadDirective } from '@app/shared/directives/defer-image-load.directive';
import { GradientHeadingComponent } from '@app/shared/components/gradient-heading/gradient-heading.component';

import { Membership } from '@app/shared/models/api-response/catalog-api-response';
import { UtilityService } from '@app/core/services/util/utility.service';

@Component({
    selector: 'app-shop-by-membership',
    standalone: true,
    imports: [NgTemplateOutlet, DeferImageLoadDirective, GradientHeadingComponent],
    templateUrl: './shop-by-membership.component.html',
    styleUrl: './shop-by-membership.component.scss'
})
export class ShopByMembershipComponent implements OnInit, OnDestroy {
    @Input() memberships: Membership[] = [];
    @Input() isMobile: boolean;

    assetsUrl: string;
    brandWisePSLAData = {};
    destroySubscription$: Subject<void> = new Subject();
    constructor(
        private outletService: OutletService,
        private bannerService: BannerService,
        private gtmService: GtmService,
        private storageService: StorageService,
        private router: Router,
        private pslaService: PslaService,
        private utilityService: UtilityService
    ) {
        this.assetsUrl = environment.assetsUrl;
    }

    ngOnInit() {
        this.pslaService.pslaNotification.pipe(takeUntil(this.destroySubscription$)).subscribe(response => {
            this.brandWisePSLAData = response.data || {};
        });
    }

    showMenuByBrand(membership: Membership, index: number) {
        const { id, override_action, label } = membership;
        if (!this.outletService.isOutletSelected()) {
            this.utilityService.openLocationSearchBar();
            return;
        }

        if (override_action) {
            this.bannerService.superSaverAction(membership, 'membership');
        } else {
            this.gtmService.logEventTracking('home_page', 'brand_tile_click', 'brand: ' + label + ', ' + 'tile_index: ' + index);
            this.storageService.set('brand_id', String(id));
            this.router.navigateByUrl('/menu');
        }
    }

    showCategoryByBrand(membership: Membership, index: number) {
        const { id, override_action, label } = membership;
        if (!this.outletService.isOutletSelected()) {
            this.utilityService.openLocationSearchBar();
            return;
        }

        this.gtmService.logEventTracking('home_page', 'brand_tile_click', 'brand: ' + label + ' ' + 'tile_index: ' + index);

        this.storageService.set('brand_id', String(id));
        if (override_action) {
            this.bannerService.superSaverAction(membership, 'membership');
        } else {
            this.router.navigateByUrl('/category');
        }
    }

    ngOnDestroy() {
        this.destroySubscription$.next();
        this.destroySubscription$.complete();
    }
}
